import { createContext } from 'react';

export default createContext({
	fdsQueryRulesChoices: [],
	canAttributesMapToFds: true,
	CanonicalOrderedUrlFragments: [],
	fdsFacetCanonicalData: [],
	setDisplayTypeId: null
});
